import * as OM from '@/model';

export class AddPrenotazioneCommentVm
{
    prenotazioneIdentifier: string;
    allegato: File;
    text: string;
    notifyUser: boolean
}

export class PrenotazioneDataVm {
    dottore: OM.DottoreForListVm;
    data: string;
    fascia: OM.TimeTableItem;
    professionIdentifier: string;
}

export class SocketMessage
{
    type: string;
    content: any;
}

export class WsPresentMessage
{
    chatRoomName: string;
    chatRoomIdentifier: string;
    userIdentifier: string;
}

export class WsDisableMessage
{
    disable: boolean;
    chatRoomIdentifier: string;
}

export class WsRemoveMessage
{
    messageIdentifier: string;
    chatRoomIdentifier: string;
}

export class WsMessage<T> {
    type: string;
    content: T;
}

export class AddCommentEvent {
    fileList: File[];
    text: string;
}

export class AddCommentVm
{
    fileList: File[];
    text: string;
    entityIdentifier: string;
}

export class SendMessageVm
{
    fromBackend: boolean;
    chatRoomIdentifier: string;
    text: string;
    senderName: string;
    senderIdentifier: string;
    clienteIdentifier: string;
    quotedMessage: OM.QuotedMessage;
}

export class CreateUserPaymentRequestVm
{
    amount: number;
    date: string;
    userIdentifier: string;
    useRitenutaAcconto: boolean;
    attachment: File;
    constructor(){
        this.amount = null;
        this.date = "";
        this.userIdentifier = "";
        this.useRitenutaAcconto = false;
        this.attachment = null;
    }
}


export class SaveToDoVm
{
    leadIdentifier: string;
    type: string;
    text: string;
    status: string;
    startDate: string;
    endDate: string;
    allegati: File[];

    constructor(){
        this.leadIdentifier = "";
        this.type = "";
        this.text = "";
        this.status = "";
        this.startDate = "";
        this.endDate = "";
        this.allegati = [];
    }
}